module.exports = __webpack_public_path__ + "img/changwon-express-asoke.f5ff7594.png";